module.exports = __webpack_public_path__ + "media/en_gb_s4_Maddy.a3981b51.mp3";